module.exports = __webpack_public_path__ + "assets/dashboard_white.95c3039c.svg";